<template>
  <div class="mt-2 flex  overflow-hidden flex-grow ">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray mr-2 ">

      <!--go back  -->
      <div class="w-full  h-10 ">
        <CGoBack/>
      </div>

      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden px-10 h-full  flex  text-center justify-center">

        <div class=" overflow-auto bg-white rounded p-10  max-w-[1000px] flex-grow">

          <div class="flex items-center justify-between h-10 mb-4 w-full rounded">
            <div class="w-full bg-primary p-2 rounded">
              <span class="text-xl "> Werbemittel typen </span>
            </div>
          </div>
          <div class="flex flex-col sm:flex-row w-full">
            <div class="w-full">
              <div class="flex mt-2 text-left w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Titel</span>
                <input class="border p-2 rounded w-3/4" v-model="titleName" data-ui="titleName">
              </div>
              <div class="flex mt-2 text-left w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Typ Namen</span>
                <input class="border p-2 rounded w-3/4" v-model="type" data-ui="type" >
              </div>
              <div class="flex mt-2 text-left w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Supportet andere Märkte</span>
                <select class="border p-2 rounded w-3/4" v-model="supportMarkets" data-ui="supportMarkets">
                  <option :value="true">Aktive</option>
                  <option :value="false">Nicht Aktiv</option>
                </select>
              </div>
              <button @click="editMagazineType" data-ui="save-magazine-type"
                      class=" mr-1 w-full rounded mt-2 p-3 bg-trader-green hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out">
                Speichern
              </button>
              <button @click="deleteTrue()" data-ui="delete-magazine-type"
                      class=" mr-1 w-full rounded mt-2 p-3 bg-trader-red hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out">
                Löschen
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <Sidebar />
  </div>
</template>


<script>

import Sidebar from "@/components/Administration/Sidebar.vue";
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import router from "@/router";
import {eventBus} from "@/application/EventBus";
import SignalBus from "@/application/SignalBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";

export default {
  components: {CGoBack, Sidebar},
  data() {
    return {
      titleName: '',
      type: '',
      supportMarkets: false,
      magazineTypeId: 0,
      magazineType: null,
      accordionIndex: 0
    }
  },
  mounted() {
    SignalBus.emit("Headline-magazine-type");
  },
  methods: {

    deleteTrue( ) {
      eventBus.openConfirm({
          message: "Möchten Sie diesem Werbemittel typen wirklich löschen?" ,
          type: "magazineType",
          onAccept: this.deleteMagazineType
        });
    },
    goBack() {
      router.push("/administration")
    },
    async deleteMagazineType(){

      const mutation = gql`
        mutation deleteMagazineType($magazineTypeId: Int!) {
          deleteMagazineType(magazineTypeId: $magazineTypeId) {
            success
            code
          }
        }
      `;

      try {
        const variables = {
          magazineTypeId: this.magazineTypeId
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        if (data.deleteMagazineType.success) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Magazine Typ gelöscht",
            message: "Der Magazine Typ wurde gelöscht.",
          });
          router.push(`/administration/${this.accordionIndex}`)
        }
        
        if (data.deleteMagazineType.code == "MAGAZINE-TAPE-USED") {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Magazine Typ wird noch in einem Magazin verwendet",
            message: "Der Magazine Typ konnte nicht gelöscht werden.",
          });
        }

      } catch (error) {
        console.error(error);
      }

    },
    async editMagazineType() {
      const magazineTypeData = {
        magazineTypeId: this.magazineTypeId,
        magazineType: this.type,
        magazineTypeTitle: this.titleName,
        supportsMarkets: this.supportMarkets
      };
      const mutation = gql`
        mutation editMagazineType($magazineType: MagazineTypeInput!) {
          editMagazineType(magazineType: $magazineType) {
            success
          }
        }
      `;

      try {
        const variables = {
          magazineType: magazineTypeData
        };

        const {data} = await apolloClient.mutate({mutation, variables});
        if (data.editMagazineType.success) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Magazine Typ gespeichert",
            message: "Der Magazine Typ wurde gespeichert.",
          });
        }
      } catch (error) {
        console.error("Daten konnten nicht geUpdatet werden ", error);
      }
    },
    async getMagazineType() {
      const query = gql`
        query getMagazineType($magazineTypeId: Int!) {
          getMagazineType(magazineTypeId: $magazineTypeId)  {
            magazineTypeId
            magazineType
            magazineTypeTitle
            supportMarkets
          }

        }
      `;
      try {
        const variables = {magazineTypeId: this.magazineTypeId};
        const {data} = await apolloClient.query({query, variables});
        this.magazineType = data.getMagazineType;
        this.titleName = this.magazineType.magazineTypeTitle
        this.type = this.magazineType.magazineType
        this.supportMarkets = this.magazineType.supportMarkets


      } catch (error) {
        console.error(error);
      }
    },
  },
  watch: {
    '$route.params.marketTypeId': function (newId, oldId) {
      this.magazineTypeId = newId;
      this.getMagazineType();
    },
  },
  created() {
    if (this.$route.params.marketTypeId != null && typeof this.$route.params.marketTypeId != 'undefined' && this.$route.params.marketTypeId != '') {
      this.magazineTypeId = this.$route.params.marketTypeId;
      
      this.getMagazineType();
    }
    this.accordionIndex = this.$route.params.accordionIndex;
  }
}
</script>
